module.exports = __webpack_public_path__ + "static/sherry_adesina-b0c05e1afa3b74f587a0c03d45a2f1bd.jpg";